import SEOHead, {
  getOrganizationSchema,
  getWebSiteSchema,
  getWebPageSchema,
  getFAQSchema,
} from '@/components/base/SEOHead';
import HeroBanner from './components/HeroBanner';
import CategorySection from './components/CategorySection';
import HotComics from './components/HotComics';
import LatestUpdates from './components/LatestUpdates';
import HomeFAQ from './components/HomeFAQ';
import { siteInfo } from '@/mocks/comics';

const faqs = [
  {
    question: '吹雪漫画网的漫画都是免费的吗？',
    answer: '是的！吹雪漫画网上所有漫画均免费提供阅读，无需付费订阅。我们致力于为广大漫画爱好者提供高品质的免费漫画阅读服务，包括黑莲花攻略手册、斗破苍穹、全职高手等热门作品均可免费观看。',
  },
  {
    question: '黑莲花攻略手册漫画是无删减版本吗？',
    answer: '当然！吹雪漫画网提供的黑莲花攻略手册漫画为无删减完整版本，保证内容与原作完全一致。我们坚持提供完整、原汁原味的漫画内容，让读者获得最佳的阅读体验。',
  },
  {
    question: '什么是下拉式阅读？如何使用？',
    answer: '下拉式阅读是一种流畅的漫画观看方式，您只需向下滑动页面，漫画内容就会自动连续展示，无需频繁点击翻页。在吹雪漫画网，所有漫画章节均采用下拉式设计，进入任意章节后直接向下滚动即可畅快阅读。',
  },
  {
    question: '漫画多久更新一次？',
    answer: '吹雪漫画网坚持每日更新，热门连载漫画如黑莲花攻略手册通常会保持每周3-4话的更新频率。我们会及时同步最新漫画章节，确保读者能第一时间看到最新章节内容。',
  },
  {
    question: '如何在手机上观看漫画？',
    answer: '吹雪漫画网采用响应式设计，完美适配手机、平板和电脑等各类设备。您只需用手机浏览器访问我们的网站，即可享受与电脑端一致的高清漫画阅读体验。下拉式设计在手机端的体验尤为出色。',
  },
];

export default function Home() {
  return (
    <>
      <SEOHead
        title={`${siteInfo.name} - ${siteInfo.slogan}`}
        description="吹雪漫画网提供黑莲花攻略手册漫画免费阅读，无删减版本保证内容完整，下拉式设计让您流畅观看。涵盖国产漫画、热血漫画、恋爱漫画、玄幻漫画等多类型高品质漫画资源。"
        keywords="黑莲花攻略手册漫画,免费阅读,无删减漫画,下拉式,吹雪漫画网,国产漫画,热血漫画,恋爱漫画"
        canonicalUrl="https://chuixue.manhua.com/"
        schemaData={{
          ...getOrganizationSchema(),
          ...getWebSiteSchema(),
          ...getWebPageSchema(
            `${siteInfo.name} - ${siteInfo.slogan}`,
            '吹雪漫画网提供黑莲花攻略手册漫画免费阅读，无删减版本保证内容完整，下拉式设计让您流畅观看。涵盖国产漫画、热血漫画、恋爱漫画、玄幻漫画等多类型高品质漫画资源。',
            'https://chuixue.manhua.com/',
          ),
          ...getFAQSchema(faqs),
        }}
      />
      <HeroBanner />
      <CategorySection />
      <HotComics />
      <LatestUpdates />
      <HomeFAQ />
    </>
  );
}